import react from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { addCommas } from "@persian-tools/persian-tools";

const EndTable = (props) => {
  const rows = props.orders;
  return (
    <TableContainer
      component={Paper}
      sx={{ backgroundColor: "pallete.primary" }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="justify">شماره سفارش</TableCell>
            <TableCell align="justify">نام پزشک</TableCell>
            <TableCell align="justify">نام بیمار</TableCell>
            <TableCell align="justify">تاریخ شروع</TableCell>
            <TableCell align="justify">تاریخ پایان</TableCell>
            <TableCell align="justify">نوع کار</TableCell>
            <TableCell align="justify">تعداد واحد</TableCell>
            <TableCell align="justify">مبلغ سفارش</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <react.Fragment>
              <TableRow>
                <TableCell align="justify">{row.orderId}</TableCell>
                <TableCell align="justify">{row.doctorName}</TableCell>
                <TableCell align="justify">{row.patientName}</TableCell>
                <TableCell align="justify">{row.startDate}</TableCell>
                <TableCell align="justify">{row.endDate}</TableCell>
                <TableCell align="justify">{row.orderTypeName}</TableCell>
                <TableCell align="justify">{row.unitCount}</TableCell>
                <TableCell align="justify">
                  {addCommas(row.afterDiscount)}
                </TableCell>
              </TableRow>
              {row.details.map((detail) => (
                <react.Fragment>
                  <TableRow>
                    <TableCell>
                      <Chip label="پیوست" color="primary" size="small" />
                    </TableCell>
                    <TableCell />
                    <TableCell colSpan={4} align="justify">
                      {detail.title}
                    </TableCell>
                    <TableCell align="justify">{detail.count}</TableCell>
                    <TableCell align="justify">
                      {addCommas(detail.discountPrice)}
                    </TableCell>
                  </TableRow>
                </react.Fragment>
              ))}
            </react.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EndTable;
